import { getFirestore, doc, setDoc as setDoc$1, deleteDoc as deleteDoc$1, collection, query, getDocs, where, onSnapshot, addDoc } from 'firebase/firestore';
import { updateShoppingCart as updateShoppingCart$1, reuseGlobalConfig, getShoppingCart as getShoppingCart$1, updateCartProductsHash, State, logDebug, checkMinimumConfigProvided, createShoppingCartSync, addProduct as addProduct$1, subtractProduct as subtractProduct$1, removeProduct as removeProduct$1, setProduct as setProduct$1, replaceProduct as replaceProduct$1, emptyShoppingCart as emptyShoppingCart$1, deleteShoppingCart as deleteShoppingCart$1, validateShoppingCart as validateShoppingCart$1, getBenefitsNode as getBenefitsNode$1, getWallet as getWallet$1, checkMinimumFetchWalletConfigProvided, buildServiceHeaders, verifyHeaders, listenBenefitsWalletUnsubscribe, logError, getInitialBenefitsWallet, updateBenefitsWallets, fetchWalletByUser, mapCollectionToBenefits, applyBenefit as applyBenefit$1, applyBenefitSync, removeBenefit as removeBenefit$1, removeBenefitsHelper, redeemCoupon as redeemCoupon$1, mergeShoppingCart as mergeShoppingCart$1, findProduct as findProduct$1 } from '@artisan-commerce/shopping-cart-core';
export { fetchStoreCouponDetail, fetchStoreCoupons, getProductHash, getShoppingCartProducts, getShoppingCartTotal } from '@artisan-commerce/shopping-cart-core';

const getCartReference = (anonymous, customerId, accountId, shoppingCartId) => {
  const db = getFirestore();
  const path = anonymous ? "anonymousShoppingCartByUser" : "shoppingCartByUser";
  const cartReference = doc(db, path, String(customerId), String(accountId), shoppingCartId);
  return cartReference;
};
const setDoc = async (config) => {
  const { reusedConfig, payload, shoppingCartNode } = config != null ? config : {};
  const { customerId, anonymous, accountId } = reusedConfig != null ? reusedConfig : {};
  const cartReference = getCartReference(anonymous, String(customerId), accountId, shoppingCartNode.id);
  await setDoc$1(cartReference, payload);
};
const deleteDoc = async (config) => {
  const { reusedConfig, shoppingCartNode } = config != null ? config : {};
  const { customerId, anonymous, accountId } = reusedConfig != null ? reusedConfig : {};
  const cartReference = getCartReference(anonymous, String(customerId), accountId, shoppingCartNode.id);
  await deleteDoc$1(cartReference);
};
const getCollectionReference = async (collectionName, ...path) => {
  const db = getFirestore();
  const cartReference = collection(db, collectionName, ...path);
  return cartReference;
};
const getDocumentsByCollections = async (collectionReference) => {
  const q = query(collectionReference);
  const querySnapshot = await getDocs(q).then((result) => result.docs[0]);
  return querySnapshot;
};

const updateShoppingCart = async (setShoppingCart, config) => {
  return updateShoppingCart$1({ getShoppingCartNode, setDoc }, setShoppingCart, config);
};

var __defProp$2 = Object.defineProperty;
var __defProps$2 = Object.defineProperties;
var __getOwnPropDescs$2 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2 = (a, b) => __defProps$2(a, __getOwnPropDescs$2(b));
const getShoppingCartNodes = (config) => {
  const reusedConfig = reuseGlobalConfig(config);
  const { accountId, customerId, anonymous } = reusedConfig;
  checkMinimumConfigProvided(reusedConfig);
  const path = anonymous ? "anonymousShoppingCartByUser" : "shoppingCartByUser";
  const db = getFirestore();
  const collectionRef = collection(db, path, String(customerId), String(accountId));
  return collectionRef;
};
const getShoppingCartNode = async (config) => {
  const reusedConfig = reuseGlobalConfig(config);
  const { shoppingCartName } = reusedConfig;
  const cartsCollection = getShoppingCartNodes(reusedConfig);
  if (!cartsCollection)
    return;
  const q = query(cartsCollection, where("name", "==", shoppingCartName));
  const querySnapshot = await getDocs(q).then((userCarts) => userCarts.docs[0]);
  return querySnapshot;
};
const getShoppingCart = async (config) => {
  const cart = await getShoppingCart$1({ getShoppingCartNode }, config);
  if (!cart)
    return cart;
  const updatedCart = updateCartProductsHash(cart);
  if (!updatedCart)
    return cart;
  updateShoppingCart((prev) => __spreadProps$2(__spreadValues$2({}, prev), { stores: updatedCart.stores }), config);
  return updatedCart;
};
const listenShoppingCart = (onSnapshot$1, config) => {
  const reusedConfig = reuseGlobalConfig(config);
  const { shoppingCartName } = reusedConfig;
  const shoppingCartDocs = getShoppingCartNodes(reusedConfig);
  if (!shoppingCartDocs)
    return () => {
    };
  State().setState({ activeShoppingCart: shoppingCartName });
  const q = query(shoppingCartDocs, where("name", "==", shoppingCartName));
  return onSnapshot(q, (snapshot) => {
    var _a;
    if (!((_a = snapshot == null ? void 0 : snapshot.docs) == null ? void 0 : _a[0])) {
      logDebug(`Failed to fetch a shopping cart with name ${shoppingCartName} because there wasn't any.`);
      return onSnapshot$1(void 0);
    }
    const cart = snapshot.docs[0].data();
    const cartProductsUpdated = updateCartProductsHash(cart);
    if (cartProductsUpdated) {
      updateShoppingCart((prev) => {
        return __spreadProps$2(__spreadValues$2({}, prev), { stores: cartProductsUpdated.stores });
      }, reusedConfig);
      return;
    }
    if ((cart == null ? void 0 : cart.id) === "" || (cart == null ? void 0 : cart.id) === null)
      return;
    return onSnapshot$1(cart);
  });
};

var __defProp$1 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1 = (a, b) => __defProps$1(a, __getOwnPropDescs$1(b));
const createShoppingCart = async (config, overrides = {}) => {
  return new Promise((resolve, reject) => {
    const action = async () => {
      try {
        const reusedConfig = reuseGlobalConfig(config);
        const { shoppingCartName } = reusedConfig;
        const cartsCollection = getShoppingCartNodes(reusedConfig);
        const newShoppingCart = createShoppingCartSync(__spreadValues$1({
          name: shoppingCartName,
          channelId: config == null ? void 0 : config.channelId
        }, overrides));
        if (!cartsCollection) {
          console.warn(`Couldn't find a shopping cart collection with the given config.
      Please make sure everything is correct in your configuration
      before continue.`);
          resolve(null);
          return null;
        }
        const { name } = newShoppingCart;
        const numberOfCarts = (await getDocs(cartsCollection)).docs.length;
        const maxNumberOfCarts = State().state.maxShoppingCarts;
        if (numberOfCarts >= maxNumberOfCarts) {
          throw new Error(`Cannot add more carts. Carts limit (${maxNumberOfCarts}) reached.`);
        }
        const q = query(cartsCollection, where("name", "==", name));
        const cartsLength = (await getDocs(q)).docs.length;
        if (cartsLength > 0) {
          throw new Error(`Attempted to create a shopping cart with the name ${name}, but there is already one shopping cart with that name.`);
        }
        const node = await addDoc(cartsCollection, newShoppingCart);
        if (!node) {
          console.error("Failed to create a new shopping cart");
          resolve(null);
          return null;
        }
        const updatedCart = __spreadProps$1(__spreadValues$1({}, newShoppingCart), { id: node.id });
        await setDoc$1(node, updatedCart);
        resolve(updatedCart);
        return updatedCart;
      } catch (e) {
        reject(e);
        return null;
      }
    };
    const { eventLoop, queue } = State().state;
    queue.enqueue(action);
    if (!eventLoop.isRunning)
      eventLoop.start();
  });
};

const addProduct = async (product, config) => {
  return addProduct$1({ getShoppingCartNode, setDoc, createShoppingCart }, product, config);
};

const subtractProduct = async (product, config) => {
  return subtractProduct$1({ getShoppingCartNode, setDoc }, product, config);
};

const removeProduct = (product, config) => {
  return removeProduct$1({ getShoppingCartNode, setDoc }, product, config);
};

const setProduct = async (product, config) => {
  return setProduct$1({ getShoppingCartNode, setDoc }, product, config);
};

const replaceProduct = (product, config) => {
  return replaceProduct$1({ getShoppingCartNode, setDoc }, product, config);
};

const emptyShoppingCart = async (config) => await emptyShoppingCart$1({ getShoppingCartNode, setDoc }, config);

const deleteShoppingCart = async (config) => await deleteShoppingCart$1({ getShoppingCartNode, deleteDoc }, config);

const validateShoppingCart = (config, headers = new Headers()) => {
  return validateShoppingCart$1({ getShoppingCartNode }, config, headers);
};

const getBenefitsNode = (config) => {
  return getBenefitsNode$1({ getBenefitsCollection: getCollectionReference }, config);
};
const getWallet = async (config) => {
  return getWallet$1({
    getBenefitsCollection: getCollectionReference,
    getBenefitsDocuments: getDocumentsByCollections
  }, config);
};

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const listenBenefitsWallet = (onSnapshot$1, config, headers = new Headers()) => {
  const reusedConfig = reuseGlobalConfig(config);
  checkMinimumFetchWalletConfigProvided(reusedConfig);
  const selectedHeaders = buildServiceHeaders(headers);
  verifyHeaders(selectedHeaders);
  const { shoppingCartName, customerId, anonymous } = reusedConfig;
  const { wallets } = State().state;
  const walletExists = wallets[shoppingCartName];
  if (anonymous)
    return () => listenBenefitsWalletUnsubscribe(shoppingCartName);
  if (walletExists) {
    logError(`There is already a listener for wallet of name ${shoppingCartName}. Either unsubscribe to the other listener or create a new listener for a different cart`);
    return () => listenBenefitsWalletUnsubscribe(shoppingCartName);
  }
  const newWallet = getInitialBenefitsWallet();
  updateBenefitsWallets(shoppingCartName, __spreadProps(__spreadValues({}, newWallet), { onSnapshot: onSnapshot$1 }));
  let dbUnsubscriber = void 0;
  (async () => {
    const fetchConfig = __spreadProps(__spreadValues({}, reusedConfig), { customerId });
    try {
      await fetchWalletByUser(fetchConfig, selectedHeaders);
      const benefitsNode = await getBenefitsNode(reusedConfig);
      if (!benefitsNode) {
        throw new Error("Failed to retrieve the benefits wallet node");
      }
      dbUnsubscriber = onSnapshot(benefitsNode, async (collection) => {
        var _a, _b, _c;
        const benefitsByUser = (_c = (_b = (_a = collection == null ? void 0 : collection.docs) == null ? void 0 : _a[0]) == null ? void 0 : _b.data()) != null ? _c : {};
        if (Object.keys(benefitsByUser).length === 0) {
          const newWallet3 = getInitialBenefitsWallet();
          updateBenefitsWallets(shoppingCartName, __spreadProps(__spreadValues({}, newWallet3), {
            onSnapshot: onSnapshot$1
          }));
          onSnapshot$1(newWallet3);
          return;
        }
        const hash = collection.docs[0].id;
        const benefits = mapCollectionToBenefits(benefitsByUser, hash);
        const newWallet2 = getInitialBenefitsWallet({
          benefits
        });
        updateBenefitsWallets(shoppingCartName, __spreadProps(__spreadValues({}, newWallet2), {
          onSnapshot: onSnapshot$1
        }));
        onSnapshot$1(newWallet2);
      });
    } catch (e) {
      console.error(e.message);
    }
  })();
  return () => listenBenefitsWalletUnsubscribe(shoppingCartName, dbUnsubscriber);
};

const applyBenefit = async (config, headers = new Headers()) => {
  return applyBenefit$1({
    getShoppingCartNode,
    applyBenefitsToCart,
    setDoc: setDoc
  }, config, headers);
};
const applyBenefitsToCart = async (config, benefit, shippingCost) => {
  const reusedConfig = reuseGlobalConfig(config);
  const { customerId, anonymous, accountId } = reusedConfig;
  const shoppingCartNode = await getShoppingCartNode(reusedConfig);
  if (!shoppingCartNode) {
    console.warn("Cannot add benefit because no shopping cart nodes were found. Please ensure you have a shopping cart before continue.");
    return;
  }
  const shoppingCart = await shoppingCartNode.data();
  const updatedCart = applyBenefitSync(shoppingCart, benefit, shippingCost);
  const cartReference = getCartReference(anonymous, customerId, accountId, shoppingCart.id);
  await setDoc$1(cartReference, updatedCart);
};

const removeBenefit = (config) => {
  return removeBenefit$1({
    getShoppingCartNode,
    removeBenefitsFromCart,
    removeProduct
  }, config);
};
const removeBenefitsFromCart = async (config, benefit, shippingCost) => {
  const reuseConfig = reuseGlobalConfig(config);
  const { customerId, anonymous, accountId } = reuseConfig;
  const shoppingCartNode = await getShoppingCartNode(reuseConfig);
  if (!shoppingCartNode) {
    console.warn(`Cannot remove benefit because no shopping cart nodes were found. Please ensure you have a shopping cart before continue.`);
    return;
  }
  const shoppingCart = await shoppingCartNode.data();
  const updatedCart = removeBenefitsHelper(shoppingCart, benefit, shippingCost);
  const cartReference = getCartReference(anonymous, String(customerId), accountId, shoppingCart.id);
  await setDoc$1(cartReference, updatedCart);
};

const redeemCoupon = async (config, code, headers = new Headers()) => {
  return redeemCoupon$1({
    getWallet,
    getShoppingCartNode
  }, config, code, headers);
};

const mergeShoppingCart = async (shoppingCart, config) => {
  return mergeShoppingCart$1({ getShoppingCartNode, setDoc }, shoppingCart, config);
};

const findProduct = async (config) => {
  return findProduct$1({ getShoppingCartNode }, config);
};

export { addProduct, applyBenefit, createShoppingCart, deleteShoppingCart, emptyShoppingCart, findProduct, getShoppingCart, listenBenefitsWallet, listenShoppingCart, mergeShoppingCart, redeemCoupon, removeBenefit, removeProduct, replaceProduct, setProduct, subtractProduct, updateShoppingCart, validateShoppingCart };
//# sourceMappingURL=bundle.mjs.map
